import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'brand_marketplace-similar_brands_cta-click';
/**
 * click on similar brands cta on logged out brand page
 */
export function trackBrandMarketplaceSimilarBrandsCtaClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
